var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveStartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    fill: "white",
    stroke: "#CD2A3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6C10.037 6 6 10.037 6 15C6 19.963 10.037 24 15 24C19.963 24 24 19.963 24 15C24 10.037 19.963 6 15 6ZM15 22.56C10.8312 22.56 7.44 19.1688 7.44 15C7.44 10.8312 10.8312 7.44 15 7.44C19.1688 7.44 22.56 10.8312 22.56 15C22.56 19.1688 19.1688 22.56 15 22.56Z",
    fill: "#CD2A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 19.6803C17.585 19.6803 19.6803 17.585 19.6803 15.0003C19.6803 12.4156 17.585 10.3203 15.0003 10.3203C12.4156 10.3203 10.3203 12.4156 10.3203 15.0003C10.3203 17.585 12.4156 19.6803 15.0003 19.6803Z",
    fill: "#CD2A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStartIcon);
export default __webpack_public_path__ + "static/media/activeStartIcon.4484ae784d613ba2e96d450567212f0f.svg";
export { ForwardRef as ReactComponent };